// Раздел «Мессенджеры» на телефоне: закреплённый канал «Телеграм».
//
// Канал — это не беседа. Его не создают и не удаляют руками: сессия
// закреплённая, сервер поднимает её сам после рестарта, и только у неё есть
// telegram-MCP. Аккаунт нельзя держать двумя процессами — Telegram аннулирует
// ключ обоим (AuthKeyDuplicatedError), — поэтому канал ровно один и второго
// быть не может. Отсюда всё остальное: ни списка, ни «+», ни закрытия.
//
// Сессию ищем по роли, а не по сохранённому id: после рестарта сервера это
// тот же самый канал, но id у него новый, а роль — свойство постоянное.
// Ровно так же его находит десктопный `shell/MessengersSection.tsx`.

import { useEffect } from 'react'
import { useAppStore } from '../store/appStore'
import ChatScreen from './ChatScreen'
import './messengers.css'

// Замок автоподъёма живёт в модуле, а не в компоненте: MobileApp размонтирует
// экран при каждой смене вкладки, и ref внутри компонента сбрасывался бы вместе
// с ним — шесть заходов на вкладку давали шесть POST /api/sessions/telegram
// подряд. Канал монопольный, долбить ручку его подъёма нельзя.
// Сбрасывается, когда канал найден: если он позже умрёт, автоподъём отработает
// снова один раз. Кнопка ниже от замка не зависит — это осознанное действие.
let autoAsked = false

export default function MessengersScreen() {
  const sessions = useAppStore((s) => s.sessions)
  const creating = useAppStore((s) => s.creating)
  const openTelegram = useAppStore((s) => s.openTelegram)

  const channel = sessions.find((session) => session.role === 'telegram') ?? null

  // Вход в раздел сам поднимает канал — как `setSection('messengers')` на
  // десктопе. Человеку тут нечего решать: сессия закреплённая, и пустой экран
  // с одной кнопкой «поднять» был бы лишним шагом на пустом месте.
  useEffect(() => {
    if (channel) {
      autoAsked = false
      return
    }
    if (autoAsked) return
    autoAsked = true
    void openTelegram()
  }, [channel, openTelegram])

  if (!channel) {
    return (
      <div className="ab-mmsg">
        <p className="ab-mmsg__hint">
          {creating
            ? 'Поднимаю канал…'
            : 'Канал ещё не поднят. Он держит Telegram-аккаунт в одиночку — второй процесс к тому же аккаунту подключиться не сможет.'}
        </p>
        <button
          type="button"
          className="ab-mmsg__start"
          disabled={creating}
          onClick={() => { void openTelegram() }}
        >
          {creating ? 'поднимаю…' : 'открыть Телеграм'}
        </button>
      </div>
    )
  }

  // Дальше это обычный экран беседы: тот же поток, та же строка ввода, та же
  // диктовка. Канал отличается не рисовкой, а тем, чем владеет, — заводить
  // ради него второй экран лога значило бы держать две копии одного кода.
  return <ChatScreen sessionId={channel.id} />
}
